import Vue from 'vue';
import Vuex from 'vuex';
import cashier from './cashier';
import pub from './public';


export default new Vuex.Store({
    modules: {
        cashier,
        pub
    }
})
